const PILLARS = [
    {
        title: "Materials",
        description:
            "We use 100% vegan soy wax derived from non-GMO crops, lead-free cotton wicks, and phthalate-free fragrance oils. No paraffin, no synthetics, no compromise.",
        stat: "100%",
        statLabel: "Natural Ingredients",
    },
    {
        title: "Packaging",
        description:
            "Our vessels are made from recycled glass and are designed to be repurposed. Outer packaging uses FSC-certified paper and water-based inks. We ship plastic-free.",
        stat: "0",
        statLabel: "Single-Use Plastic",
    },
    {
        title: "Carbon",
        description:
            "We offset 120% of our shipping emissions through verified reforestation projects. Our London studio runs on 100% renewable energy. We measure everything.",
        stat: "120%",
        statLabel: "Emissions Offset",
    },
];

export function Commitments() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-24">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                {PILLARS.map((pillar) => (
                    <div key={pillar.title} className="space-y-6 border-t border-stone-200 pt-8">
                        <div>
                            <p className="font-serif text-5xl font-light text-stone-800">{pillar.stat}</p>
                            <p className="text-xs uppercase tracking-widest text-stone-400 mt-1">{pillar.statLabel}</p>
                        </div>
                        <h3 className="font-serif text-2xl">{pillar.title}</h3>
                        <p className="text-stone-500 font-light leading-relaxed">{pillar.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
